import View from '@/Views/View';
import { IAsyncElementProvider, IAsyncTupleProvider } from '#/DefaultViewExtensionInterfaces';
import ViewTuple from '@/Views/ViewTuple';

export default abstract class AsyncView extends View implements IAsyncElementProvider, IAsyncTupleProvider<ViewTuple> {
    protected constructor() {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        throw new Error("'getView' is not supported in 'AsyncView'");
    }

    public async getTupleAsync(): Promise<ViewTuple> {
        if (this.tuple)
            return this.tuple;

        const $view = await this.getElementAsync();
        this.tuple = new ViewTuple(this, $view);
        return this.tuple;
    }

    public abstract getElementAsync(): Promise<JQuery<HTMLElement>>;
}